import AOS from 'aos'
import { color } from 'constants/color'
import { useDarkMode } from 'hooks/useDarkMode'
import i18n from 'plugins/i18n'
import { lazy, Suspense, useEffect } from 'react'
import { I18nextProvider, withTranslation } from 'react-i18next'
import MessengerCustomerChat from 'react-messenger-customer-chat'
import ProgressBar from 'react-scroll-progress-bar'
import { ThemeProvider } from 'styled-components'
import { darkTheme, GlobalStyles, lightTheme } from 'styles/themes/GlobalStyles'
import isDev from 'utils/isDev'
import { LSManager } from 'utils/localstoragemanager'
import loader from 'assets/loading-doge.gif'
require('dotenv').config()

const App: React.FC = () => {
  const pageId = process.env.REACT_APP_FACEBOOK_PAGE_ID
  const appId = process.env.REACT_APP_FACEBOOK_APP_ID
  useEffect(() => {
    AOS.init({
      duration: 2000,
    })
    if (LSManager.getLanguage() === '') LSManager.setLanguage('en')
  }, [])

  if (isDev()) {
    console.log('======> App is on', process.env.NODE_ENV)
  }

  const [theme, toggleTheme] = useDarkMode()
  const themeMode = theme === 'light' ? lightTheme : darkTheme
  const Layout = lazy(() => import('../layout'))
  return (
    <ThemeProvider theme={themeMode}>
      <I18nextProvider i18n={i18n}>
        <GlobalStyles />
        <ProgressBar bgcolor={color.PRIMARY} />
        <Suspense
          fallback={
            <div className="flex justify-center h-screen items-center">
              <div className="flex flex-col justify-center items-center">
                <img src={loader} width={60} height={60} alt="loader" />
                <p className="text-lg font-black">Loading...</p>
              </div>
            </div>
          }
        >
          <Layout theme={theme} toggleTheme={toggleTheme} />
        </Suspense>
        <MessengerCustomerChat
          pageId={pageId}
          appId={appId}
          themeColor={color.PRIMARY}
        />
      </I18nextProvider>
    </ThemeProvider>
  )
}

export default withTranslation()(App)
